// Copyright (c) 2019 Comsearch, Inc., All rights reserved

// gets throughput of the assigned engineering reference.
const getEngineeringReferenceThroughput = ({ engineeringReference, modulations }) => (
  modulations.find(d => d.radioModulationId === engineeringReference)?.throughput
)

export default getEngineeringReferenceThroughput
